import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { EditPracticePage } from '@/pages/EditPractice'

export const Route = createFileRoute('/_authenticated/practices_/$practiceId_/edit')({
  component: EditCustomerGuard,
})

function EditCustomerGuard() {
  return (
    <PermissionRouteGuard resource="customer_profiles" action="update">
      <EditCustomerRoute />
    </PermissionRouteGuard>
  )
}

function EditCustomerRoute() {
  const { practiceId } = Route.useParams()
  return <EditPracticePage customerId={practiceId} />
}
